import { FC, memo, useEffect, useState } from 'react'

import ImageTransport from '../../../transports/common/image-transport'
import ImageLoadingComponent from '../../app-components/image-loading-component'
import { CarouselImage, SlidePlaceholder } from './styles'

export type LazyCarouselSlidesProps = {
    images: ImageTransport[]
    aspectRatio?: string
    horizontalCardHeight?: string
    isAboveFold?: boolean
    imwidth?: number
    selectedIndex?: number
}

const LazyCarouselSlides: FC<LazyCarouselSlidesProps> = ({
    images,
    aspectRatio,
    horizontalCardHeight,
    isAboveFold = false,
    imwidth,
    selectedIndex = 0,
}) => {
    const [loadedSlides, setLoadedSlides] = useState<Set<number>>(() => new Set([0]))

    useEffect(() => {
        setLoadedSlides(prev => {
            const next = new Set(prev)
            const totalSlides = images.length
            next.add(selectedIndex)
            next.add((selectedIndex + 1) % totalSlides)
            next.add((selectedIndex - 1 + totalSlides) % totalSlides)
            if (next.size === prev.size) return prev
            return next
        })
    }, [selectedIndex, images.length])

    return (
        <>
            {images.map((image, index) => {
                const imageUrl = image.url && imwidth ? `${image.url}?imwidth=${imwidth}` : image.url
                return (
                    <CarouselImage key={image.url} horizontalCardHeight={horizontalCardHeight}>
                        {loadedSlides.has(index) ? (
                            <ImageLoadingComponent
                                src={imageUrl}
                                alt={image.alt}
                                paddingTop={aspectRatio}
                                isEager={isAboveFold && index === 0}
                            />
                        ) : (
                            <SlidePlaceholder paddingTop={aspectRatio} />
                        )}
                    </CarouselImage>
                )
            })}
        </>
    )
}

export default memo(LazyCarouselSlides)
